import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LaunchIcon from "@mui/icons-material/Launch";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const ShareAutomationDialog = ({ open, onClose, shareLink, onCopy }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Share Automation</DialogTitle>
        <DialogContent>
          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <TextField
              value={shareLink}
              fullWidth
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
              size="small"
            />
            <IconButton onClick={onCopy} edge="end" aria-label="Copy link">
              <ContentCopyIcon />
            </IconButton>
            <IconButton
              href={shareLink}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              edge="end"
              aria-label="Open link"
            >
              <LaunchIcon />
            </IconButton>
          </Box>

          <Typography variant="caption" color="text.secondary" mt={2}>
            Send this link to other users. They can apply the same automation
            for their space.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShareAutomationDialog;
